module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0150.jpg?v=e3b9247c";